module.exports = __webpack_public_path__ + "fonts/c357a65e-dd87-4d11-8063-db04802d44c0.6a04a5df.woff";